import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Subscription } from 'rxjs';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { AppState } from '../../../business-entities/app-state.interface';
import { DealerSearchRequestModel } from '../../../business-entities/dealer-search-request-model.interface';
import { DealerCapacity, DealerService, MechanicSlots, PlanningSlots, ReserveSlotsTime } from '../../../business-entities/dealer-service.interface';
import { Features } from '../../../business-entities/step.class';
import { WidgetCustomerVehicleDetails } from '../../../business-entities/widget-customer-vehicle-details-model';
import { SelectDealer } from '../../../business-services/select-dealer.service';
import { SettingService } from '../../../business-services/setting.service';
import * as CommonEnums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import { Utility } from './../../../../../../Autofacets-Core/src/app/utils/utility';
import { AdditionalService } from './../../../business-entities/additional-service.interface';
import { GenericRentalCar, RentalCar } from './../../../business-entities/rental-car.interface';
import { Service } from './../../../business-entities/service.interface';
import { WorkShopSections } from './../../../business-entities/workshops-section.interface';
import { CommonService } from './../../../services/commom.service';
import * as Constant from './../../../utils/contstants';
import * as Enums from './../../../utils/enums';
import { MapComponent } from './map/map.component';
import { SelectDealerComponent } from './select-dealer/select-dealer.component';

interface WorkshopSectionDetails {
  selectedDealer: DealerService;
  selectedDate: string;
  displaySelectedDate: Date;
  timeSlotSection: boolean;
  availCheckInFacility: boolean;
  deliverCarWithinBusinessHours: boolean;
  pickupCarWithinBusinessHours: boolean;
  isNeedRentalCar: boolean;
  selectedRentalCar: RentalCar;
  rentalCarDetails: RentalCar[];
  additionalComments: string | null;
  customerPickupDropOffServiceSelection: boolean;
  PickupDatetime: Date;
  pickUpHours: number;
  pickUpMinutes: number;
  AppointmentDateTime: Date;
  appointmentHour: number;
  appointmentMinute: number;
  selectedSlot: any;
}
@Component({
  selector: 'app-select-workshop',
  templateUrl: 'select-workshop.component.html',
  styleUrls: ['./select-workshop.component.css']
})
export class SelectWorkshopComponent implements OnInit {
  currentLanguage: string
  repairTime = 0;
  formattedrepairTime: any;
  dealerNextAvailDate: string;
  selectedDate: string;
  displaySelectedDate: Date;
  dealer: any;
  allDealerDeatils: DealerService[] = [];
  preferedDealer: DealerService;
  dealerCapacity: DealerCapacity[] = [];
  mechanicSlots: MechanicSlots[] = [];
  splitMechanicSlots: MechanicSlots[] = [];
  disableDatesOfCalender = Array<string>();
  rentalCarAvailabilities: RentalCar[] = [];
  genericRentalCarList: GenericRentalCar[] = [];
  rentalCarAvailabilityDates = [];
  rentalCarNotAvailabilityDates = [];
  selectedRentalCarIndex: number;
  selectedGenericRentalCarIndex: number;
  isNeedRentalCar: boolean;
  timeSlotSection: boolean;
  customerPickupDropOffServiceSelection: boolean;
  availCheckInFacility: boolean = true;
  deliverCarWithinBusinessHours = true;
  pickupCarWithinBusinessHours = true;
  dealerOpeningHours: { days: string[], hours: string }[] = [];
  sections: WorkShopSections;
  selectedService: Service[] = [];
  additionalComments: string;
  weekends: string[] = [];
  dealerRecommendedService: AdditionalService[] = [];
  additionServicesForm: FormGroup;
  disableNextButton = true;
  rentalCarValidationMessage = false;
  isPickupFormSubmitted = false;
  pickUpHours: number;
  pickUpMinutes: number;
  AppointmentHour: number;
  AppointmentMinutes: number;
  PickupDatetime: Date;
  AppointmentDatetime: Date;
  isRentalCarSelectedError = false;
  stonchip: string;
  rentalService: boolean = false;
  isVerify: boolean
  message: string;
  currentlagSub: Subscription;
  currentlanguage: string;
  features: Features[] = [];
  isOTP: boolean = true;
  DealerServiceResp: any[] = [];
  endDate: string;
  businesshours: string;
  appData: AppState;
  selectedDay: number;
  ValidAppointmentTime: any;
  isGenericRentalCar: boolean = false;
  showLegends: boolean = false;
  ReserveSlotsTime: ReserveSlotsTime[] = []
  PlanningSlots: PlanningSlots[] = [];
  time: any = 0;
  selectedCustomerVehicleDetails: WidgetCustomerVehicleDetails;
  nextAvailbleDate: any;
  planningStartDate: Date;
  planningEndDate: Date;
  IsGenericRentalcarService:boolean;
  isShareBoxEnable: boolean = false;
  NextAvailDate: string;
  IsShowPreferedDealer: boolean = false;
  formatedTotalServiceTime;
  formatedTotalServiceTimeDate: any;
  isPickUpDropOff: boolean = false;
  selectedSlot: any = null;
  onlineCheckinFacility: boolean = false;
  tempslot: any = null;
  defaultNextAvailableDate: Date;
  widgetAppointmentTimer:boolean = false;
  genericRentalCar: RentalCar = {
    licensePlate: '',
    makeName: '',
    model: '',
    vehicleId: 0,
    notAvailableDates: null,
    price: 0
  };
  @Output() openAnotherPanelRequest = new EventEmitter<string>();

  @ViewChild('rentalCarBookingCalendar') rentalCarBookingCalendar: ElementRef;
  @ViewChild("pickUpminuteInput") pickUpminuteInput: ElementRef;
  @ViewChild("AppointmentminuteInput") AppointmentminuteInput: ElementRef;
  @ViewChild("vehiclePickUpDropOffMinutesInput") vehiclePickUpDropOffMinutesInput: ElementRef;
  @ViewChild("deliveryPickUpDropOffMinutesInput") deliveryPickUpDropOffMinutesInput: ElementRef;



  constructor(
    private readonly modalService: NgbModal,
    private readonly commonService: CommonService,
    private readonly sdService: SelectDealer,
    private readonly spinner: NgxSpinnerService,
    public settingService: SettingService,
    private readonly toastr: ToastrService,
    private readonly translateService: TranslateService,
    private readonly currentLanguageService: CurrentLanguage,
    private readonly secureStorage: SecureStorage,
    private readonly cdr: ChangeDetectorRef,
    public datepipe: DatePipe
  ) {
    this.sections = {
      dateTimeSelection: true,
      finalSummarySection: false
    };
  }

  ngOnInit(): void {
    this.initialize();
    this.message = this.translateService.instant("lbl(ThisMayAffectAvailableDays)");
  }

  async initialize() {
    if (this.secureStorage.getKeyData('feature')) {
      this.features = this.secureStorage.getKeyData('feature');
      if (this.features?.length > 0) {
        this.isOTP = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.OTP)?.isActive
        this.isShareBoxEnable = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.ShareBox)?.isActive;
        this.isPickUpDropOff = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.PickupDropoff)?.isActive;
        this.widgetAppointmentTimer = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.WidgetAppointmentTimer)?.isActive;
      }
    }
    const appData = this.commonService.getAppData();
    this.appData = appData;
    this.preferedDealer = appData.preferedDealer;
    this.stonchip = appData.otherIssuesInput;
    this.displaySelectedDate = appData.displaySelectedDate;
    this.selectedSlot = appData.selectedSlot;
    this.tempslot = appData.selectedSlot;
    this.IsShowPreferedDealer = false;
    await this.getAllDealerDetails();
      if (appData.dealerServiceDetails) {
        this.additionalComments = appData.additionalComments;
        this.AppointmentHour = appData.appointmentHour;
        this.AppointmentMinutes = appData.appointmentMinute;
  
        this.initializePreferDealer();
      }
    this.NextAvailDate = Utility.GetFormattedDate(this.preferedDealer.nextAvailableDate);
    this.selectedDate = appData.displaySelectedDate ? Utility.GetFormattedDate(appData.displaySelectedDate) : Utility.GetFormattedDate(this.preferedDealer.nextAvailableDate);
    this.defaultNextAvailableDate = this.preferedDealer.nextAvailableDate;
    this.disableDealerNotAvailableDates(this.preferedDealer.nextAvailableDate);
  }

  initializePreferDealer(): void {
    const appData = this.commonService.getAppData();
    if (appData.selectedDealer) {
      this.setSelectedDealerAsPreferDealer();
      this.initializeRentalCarVariables();
      this.initializeCheckInAndTimeSlotVariables();
      this.findDates(appData.selectedDealer.nextAvailableDate);
      this.calculateTotalRepairTime();
      this.checkRentalCarFeature(appData.selectedDealer.dealerId);
      this.getBusineesHour(appData.selectedDealer.nextAvailableDate);
    } else {
      this.findPreferedDealer();
    }
  }
  checkRentalCarFeature(dealerId: string) {
    this.settingService.getFeaturesByDealerId(dealerId).then((res) => {
      if (res.responseObject.errorCount === 0) {
        let features = res.responseObject?.result;
        if (features !== null && features !== undefined && features.length > 0) {
          this.rentalService = features?.find(x => x.featureCode === CommonEnums.FeatureCode.RenatlCar)?.isActive
          this.onlineCheckinFacility = features?.find(x => x.featureCode === CommonEnums.FeatureCode.OnlineCheckin)?.isActive
        }
        else {
          this.rentalService = false;
          this.onlineCheckinFacility = false;
        }
      }
    })
  }
  async getDealerCapacity(dealerId: string, estimatedTime: number, month: number, year: number, serviceId: string, event: any) {
    this.spinner.show();
    this.dealerCapacity = [];
    let vehicleDetail = this.commonService.getSelectedCustomerVehicleDetails();
    let model = {
      DealerId: dealerId,
      Month: month,
      Year: year,
      EstimatedTime: +((+estimatedTime.toFixed(2)) / 60).toFixed(2),
      ServiceIds: serviceId,
      vehicleType: vehicleDetail.vehicleType,
      companyMakeCode: vehicleDetail.companyMakeCode
    }
    await this.sdService.GetDealerCapacity(model).then(async (res) => {
      // res && res?.responseObject?.result && res?.responseObject?.result?.length > 0
      if (res && res?.responseObject?.result?.length > 0) {
        this.dealerCapacity = res?.responseObject?.result;
      }
      await this.disableDealerNotAvailableDates(event);
      this.spinner.hide();
    })
  }

  findDates(d: any) {
    this.disableDealerNotAvailableDates(d);
    const date = this.getNextYearDate();
    this.endDate = Utility.GetFormattedDate(date);
  }
  setSelectedDealerAsPreferDealer(): void {
    const appData = this.commonService.getAppData();
    let dealer = appData.selectedDealer;
    const dealerNotAvailableServices = this.getDealerNotAvailableServicesFromSelectedServices(dealer);
    this.preferedDealer = { ...appData.selectedDealer, notAvailableServices: dealerNotAvailableServices.join(', ') };
  }

  initializeRentalCarVariables(): void {
    const appData = this.commonService.getAppData();
    if (appData.selectedRentalCar) {
      this.isNeedRentalCar = true;
      this.rentalCarAvailabilities = appData.rentalCars;
      this.getDealerRentalCars();
      if (this.isGenericRentalCar) {
        this.selectedGenericRentalCarIndex = this.appData.genericRentalCar.typeId;
        this.isRentalCarSelectedError = !this.selectedGenericRentalCarIndex;
      }
      else {
        this.selectedRentalCarIndex = this.rentalCarAvailabilities.findIndex(x => x.vehicleId === appData.selectedRentalCar.vehicleId);
        this.isRentalCarSelectedError = !this.selectedRentalCarIndex;
      }


    }
  }

  initializeCheckInAndTimeSlotVariables(): void {
    const appData = this.commonService.getAppData();
    if (appData.timeSlotSection) {
      this.timeSlotSection = true;
      this.availCheckInFacility = appData.availCheckInFacility;
      this.deliverCarWithinBusinessHours = undefined;
      this.pickupCarWithinBusinessHours = undefined;

    } else {
      this.availCheckInFacility = appData.availCheckInFacility;
      this.deliverCarWithinBusinessHours = appData.deliverCarWithinBusinessHours;
      this.pickupCarWithinBusinessHours = appData.pickupCarWithinBusinessHours;
    }
    if (appData.isPickupDropOffServiceSelection) {
      this.customerPickupDropOffServiceSelection = true;
      this.pickUpHours = appData.pickUpHours;
      this.pickUpMinutes = appData.pickUpMinutes;
    } else {
      this.pickUpHours = undefined;
      this.pickUpMinutes = undefined;
    }
  }

  calculateTotalRepairTime(): void {
    this.time = 0;
    this.repairTime = 0;
    const appData = this.commonService.getAppData();
    this.selectedService = appData.selectedService;
    let repairTimeArr = []
    if (this.selectedService && this.selectedService.length > 0) {
      let service = this.selectedService.map(x => x.id);
      service?.forEach(x => {
        let temp = this.preferedDealer.service.findIndex(a => a.serviceId === x);
        if (temp !== -1) {
          let duration = this.preferedDealer.service[temp].duration
          repairTimeArr.push(duration);
        }
        else {
          let serviceduration = this.selectedService.filter(y => y.id === x)[0].duration;
          repairTimeArr.push(serviceduration);
        }
      })
    }
    repairTimeArr?.forEach(x => this.repairTime += +x);
    this.time = this.repairTime;
    this.repairTime = this.repairTime / 60;
    this.formattedrepairTime = Number(Number(this.repairTime).toFixed(2));
    this.formatedTotalServiceTime = Math.floor((this.formattedrepairTime * 60) / 60) + '.' + Math.round((this.formattedrepairTime * 60) % 60);
    const [h, m] = this.formatedTotalServiceTime.split('.');
    this.formatedTotalServiceTimeDate = new Date();
    this.formatedTotalServiceTimeDate.setHours(h);
    this.formatedTotalServiceTimeDate.setMinutes(m);
  }

  checkPickupTimeSlot(): void {
    const appData = this.commonService.getAppData();
    if (this.timeSlotSection) {
      this.spinner.show();
      let model = {
        selectedDate: Utility.getDateStringToDate(this.selectedDate).toDateString(),
        dealerId: this.preferedDealer.dealerId
      }
      this.sdService.GetCustomerWaitingLimit(model).then((res) => {
        if (res.responseObject > 0) {
          this.timeSlotSection = true
        }
        else {
          this.timeSlotSection = false;
          let Msg = this.translateService.instant("lblCustomerWaitingLimitExceeded");
          this.toastr.warning(Msg);
        }
      })
      this.spinner.hide();
    }
    this.nextButtonDisableCheck();
  }

  onChangeCustomerPickupDropupServiceCheckbox() {
    this.timeSlotSection = false;
    if (this.customerPickupDropOffServiceSelection) {
      this.availCheckInFacility = undefined;
      this.deliverCarWithinBusinessHours = undefined;
      this.pickupCarWithinBusinessHours = undefined;
    }
    else {
      this.availCheckInFacility = true;
      this.deliverCarWithinBusinessHours = true;
      this.pickupCarWithinBusinessHours = true;
      this.pickUpHours = undefined;
      this.pickUpMinutes = undefined;
    }
    this.nextButtonDisableCheck();
  }

  CheckMinute(_e) {
    if (this.pickUpMinutes >= 60) {
      this.pickUpMinutes = 59;
    }
    this.nextButtonDisableCheck();
  }
  CheckAppointmentMinute(_e) {
    if (this.AppointmentMinutes >= 60) {
      this.AppointmentMinutes = 59;
    }
    this.nextButtonDisableCheck();
  }

  MoveToDurationMinute(e) {
    this.MoveToMinute(e, true);
    this.nextButtonDisableCheck();
  }
  MoveToAppointmentDurationMinute(e) {
    this.MoveAppointmentToMinute(e, true);
    this.nextButtonDisableCheck();
  }
  MoveAppointmentToMinute(e, isToDuration = false) {
    //keyss to ignore
    const ignoreKeyCodes: Array<number> = [16, 9];

    //ignore keys check
    if (!ignoreKeyCodes.some(x => x == e.keyCode)) {
      //get the current element
      const target = e.srcElement;
      const maxLength = parseInt(target.attributes["maxlength"].value, 10);
      const myLength = target.value.length;
      //make a length check
      if (myLength >= maxLength) {
        //grab to element to focus on
        if (this.AppointmentHour >= 24) {
          this.AppointmentHour = 23;
        }
        let minInput;
        if (isToDuration) {
          minInput = this.AppointmentminuteInput.nativeElement;
        }
        if (minInput) {
          //focus the element
          minInput.focus();
        }
      }
    }
  }
  MoveToMinute(e, isToDuration = false) {
    //keyss to ignore
    const ignoreKeyCodes: Array<number> = [16, 9];

    //ignore keys check
    if (!ignoreKeyCodes.some(x => x == e.keyCode)) {
      //get the current element
      const target = e.srcElement;
      const maxLength = parseInt(target.attributes["maxlength"].value, 10);
      const myLength = target.value.length;
      //make a length check
      if (myLength >= maxLength) {
        //grab to element to focus on
        if (this.pickUpHours >= 24) {
          this.pickUpHours = 23;
        }
        let minInput;
        if (isToDuration) {
          minInput = this.pickUpminuteInput.nativeElement;
        }
        if (minInput) {
          //focus the element
          minInput.focus();
        }
      }
    }
  }

  onChangeCustomerWaitingCheckbox(): void {
    if (this.timeSlotSection) {
      let model : GenericRentalCar={
        id : 0,
        price : null,
        type : null,
        typeId : 0,
        additionalCharges : null
      }
      this.availCheckInFacility = true;
      this.deliverCarWithinBusinessHours = undefined;
      this.pickupCarWithinBusinessHours = undefined;
      this.isNeedRentalCar = false;
      this.selectedGenericRentalCarIndex = null ;
       this.genericRentalCarList = [];
       this.commonService.addGenericRentalCarData(this.isGenericRentalCar, model);
       this.RentalCarValidationMessage();
    }
    else {
      this.availCheckInFacility = true;
      this.deliverCarWithinBusinessHours = true;
      this.pickupCarWithinBusinessHours = true;
    }
    this.checkPickupTimeSlot();
  }

  goToDateTimeSection(): void {
    this.mechanicSlots.forEach((element, index) => {
      if (element.startTime === this.appData.planningStartTime && element.endTime === this.appData.planningEndTime) {
        this.selectedSlot = element;
      }
    });
    this.changeSection(Constant.selectWorkshopSectionConstant.dateTimeSelection);
  }

  goToSummarySection(): void {
    this.changeSection(Constant.selectWorkshopSectionConstant.finalSummarySection);
  }
  

  completeSelectWorkshop(): void {
    const index = this.allDealerDeatils.findIndex(x => x.dealerId === this.preferedDealer.dealerId);
    const details: WorkshopSectionDetails = {
      selectedDealer: this.allDealerDeatils[index],
      selectedDate: this.selectedDate,
      displaySelectedDate: this.AppointmentDatetime,
      timeSlotSection: this.timeSlotSection,
      availCheckInFacility: this.onlineCheckinFacility ? this.availCheckInFacility : false,
      deliverCarWithinBusinessHours: this.deliverCarWithinBusinessHours,
      pickupCarWithinBusinessHours: this.pickupCarWithinBusinessHours,
      isNeedRentalCar: this.isNeedRentalCar,
      selectedRentalCar: this.genericRentalCar,
      rentalCarDetails: this.rentalCarAvailabilities,
      additionalComments: (this.additionalComments) ? this.additionalComments : null,
      customerPickupDropOffServiceSelection: this.customerPickupDropOffServiceSelection,
      PickupDatetime: this.PickupDatetime,
      pickUpHours: this.pickUpHours,
      pickUpMinutes: this.pickUpMinutes,
      AppointmentDateTime: this.AppointmentDatetime,
      appointmentHour: this.AppointmentHour,
      appointmentMinute: this.AppointmentMinutes,
      selectedSlot: this.selectedSlot
    };
    if (this.isGenericRentalCar) {
      
      
      if (this.selectedGenericRentalCarIndex !== undefined && this.selectedGenericRentalCarIndex !== null) {
        let car = this.genericRentalCarList.filter(x => x.typeId === this.selectedGenericRentalCarIndex)[0];
        if(car){
        this.genericRentalCar.licensePlate = car.typeId.toString();
        this.genericRentalCar.makeName = car.type;
        this.genericRentalCar.model = car.price;
      }
      }

      
      this.commonService.addSelectWorkshopSectionDetails(details);
    }
    else {
      this.commonService.addSelectWorkshopSectionDetails(details);
    }

    this.commonService.completePanel(Enums.PanelIds.Panel3);
    this.openAnotherPanelRequest.emit(Enums.PanelIds.Panel4);
  }

  async getAllDealerDetails() {
    const viewModel: DealerSearchRequestModel = this.getDealerSearchRequestModel();
    this.spinner.show();
    await this.sdService.GetAllDealerDetails(viewModel)
      .then((result) => {
        if (result.responseObject.result.length == 0) {
          let Msg = this.translateService.instant("lblVehicleDealerNotAssociated");
          this.toastr.error(Msg);
          this.spinner.hide();
          this.openAnotherPanelRequest.emit(Enums.PanelIds.Panel2);
          return;
        }
        if (result.responseObject && result.responseObject.errorCount === 0 &&
          result.responseCode === CommonEnums.ErrorCodes.SuccessCode) {
          this.allDealerDeatils = result.responseObject.result as DealerService[];
          this.commonService.addDealerServiceDetails(this.allDealerDeatils);
          if (!(this.IsShowPreferedDealer)) {
            this.findPreferedDealer();
          }
          else {
            this.preferedDealer.occasionWiseOpeningHoursList = this.allDealerDeatils.filter(x => x.dealerId == this.preferedDealer.dealerId)[0].occasionWiseOpeningHoursList
            this.preferedDealer.occasionWiseOpeningHoursList.forEach(element => {
              let openTime = this.datepipe.transform(element?.openingTimeHrs, 'HH:mm');
              let closeTime = this.datepipe.transform(element?.closingTimeHrs, 'HH:mm');
              element.openingHours = openTime + '-' + closeTime
            });
          }
        }
        this.spinner.hide();
      });
  }

  ngOnDestroy(): void {
    if (this.currentlagSub) {
      this.currentlagSub.unsubscribe();
    }
  }


  getDealerSearchRequestModel(): DealerSearchRequestModel {
    const appdata = this.commonService.getAppData();
    this.selectedCustomerVehicleDetails = this.commonService.getSelectedCustomerVehicleDetails();
    let dateFormatRegistrationDate = Utility.getDateStringToDate(Utility.GetFormattedDate(this.selectedCustomerVehicleDetails.registrationDate));
    let date = new Date();
    let vehicleAge = Utility.monthDiff(dateFormatRegistrationDate, date);
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(x => {
      this.currentlanguage = x;
    })
    let mileage;

      if (appdata.mileage == null) {
        mileage = (this.selectedCustomerVehicleDetails.previousKilometer == null) ? 0 : this.selectedCustomerVehicleDetails.previousKilometer;
      } else {
        mileage = appdata.mileage;
      }
    const model: DealerSearchRequestModel = {
      CustomerLatitude: this.selectedCustomerVehicleDetails.latitude,
      CustomerLongitude: this.selectedCustomerVehicleDetails.longitude,
      VehicleBrand: this.selectedCustomerVehicleDetails.companyMakeCode,
      Language: this.currentlanguage ? this.currentlanguage : 'en-US',
      vehicleType: this.selectedCustomerVehicleDetails.vehicleType,
      fuelType: this.selectedCustomerVehicleDetails.fuelType,
      isActiveTodayBooking: EnvSetting.IsActiveTodayBooking !== '0',
      // mileage: (appdata.mileage == null) ? ((this.selectedCustomerVehicleDetails.previousKilometer == null) ? 0 : this.selectedCustomerVehicleDetails.previousKilometer) : appdata.mileage,
      mileage: mileage,
      vehicleAge: vehicleAge,
      selectedDate: this.displaySelectedDate,
      selectedCalenderDate: (this.selectedDate) ? Utility.getDateStringToDate(this.selectedDate) : null
    };
    return model;
  }

  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }

  findPreferedDealer(): void {
    const appData = this.commonService.getAppData();
    let service = appData.selectedService.map((x) => x.id).join(",");
    let dmsServiceIds = appData.selectedService.map((x) => x.dmsServiceId).join(",");
    const dealerWithDistance = this.allDealerDeatils.filter(x => x.distance !== 0);
    let sortedDealerList = [];
    if (dealerWithDistance.length === 0) {
      sortedDealerList = this.allDealerDeatils;
    }
    else {
        sortedDealerList = [...dealerWithDistance];
        sortedDealerList.sort((x, y) => x.distance - y.distance);
    }
    let preferedDealerFound = false;
    if (!this.empty(this.selectedCustomerVehicleDetails.preferredDealerId)) {

      if (sortedDealerList.filter(x => x.dealerId == this.selectedCustomerVehicleDetails.preferredDealerId).length > 0) {
        let preferDealer = sortedDealerList.find(x => x.dealerId == this.selectedCustomerVehicleDetails.preferredDealerId);

        preferedDealerFound = true;
        const notAvailableServices = this.getDealerNotAvailableServicesFromSelectedServices(preferDealer);
        this.preferedDealer = { ...preferDealer, notAvailableServices: notAvailableServices.join(', ') };
        this.displaySelectedDate = this.preferedDealer.nextAvailableDate;
        this.commonService.addPrefferedDealerdetails(this.preferedDealer);
      }
    }

    if (!preferedDealerFound) {

      // tslint:disable-next-line: prefer-for-of
      for (let value of sortedDealerList) {
        const dealer = value;
        const notAvailableServices = this.getDealerNotAvailableServicesFromSelectedServices(dealer);
        if (notAvailableServices.length === 0) {
          preferedDealerFound = true;
          this.preferedDealer = { ...dealer, notAvailableServices: null };
          this.commonService.addPrefferedDealerdetails(this.preferedDealer);
          this.displaySelectedDate = this.preferedDealer.nextAvailableDate
          this.preferedDealer.occasionWiseOpeningHoursList.forEach(element => {
            let openTime = this.datepipe.transform(element?.openingTimeHrs, 'HH:mm');
            let closeTime = this.datepipe.transform(element?.closingTimeHrs, 'HH:mm');
            element.openingHours = openTime + '-' + closeTime
          });

          break;
        }
      }
      if (!preferedDealerFound) {
        let preferDealer = sortedDealerList[0];
        const notAvailableServices = this.getDealerNotAvailableServicesFromSelectedServices(preferDealer);
        this.preferedDealer = { ...sortedDealerList[0], notAvailableServices: notAvailableServices.join(', ') };
        this.commonService.addPrefferedDealerdetails(this.preferedDealer);
      }
    }


    const date = this.getNextYearDate();
    this.endDate = Utility.GetFormattedDate(date);

    if (!this.timeSlotSection && this.isNeedRentalCar) {
      this.getDealerRentalCars();
    }
    this.nextButtonDisableCheck();
    this.getBusineesHour(this.displaySelectedDate);
    this.calculateTotalRepairTime();
    this.checkRentalCarFeature(this.preferedDealer.dealerId);

    const selDate = this.displaySelectedDate ? new Date(this.displaySelectedDate) : new Date(this.preferedDealer.nextAvailableDate);
    const dispDate = this.displaySelectedDate ? this.displaySelectedDate : this.preferedDealer.nextAvailableDate
    if (this.time > +(EnvSetting.ShiftTime)) {
      this.getDealerCapacity(this.preferedDealer?.dealerId, 0, (selDate.getUTCMonth() + 1), selDate.getUTCFullYear(), service, dispDate);
      this.getSplitMechanicSlots(this.preferedDealer?.dealerId, selDate, this.time, service)
    }
    else {
      this.getDealerCapacity(this.preferedDealer?.dealerId, this.time, (selDate.getUTCMonth() + 1), selDate.getUTCFullYear(), service, dispDate);
      this.getMechanicSlots(this.preferedDealer?.dealerId, selDate, this.time, service,dmsServiceIds)
    }
  }

  getBusineesHour(date: Date) {
    let today = (new Date(date)).getDay();
    this.appData = this.commonService.getAppData();
    this.preferedDealer.occasionWiseOpeningHoursList.forEach(element => {
      let openTime = this.datepipe.transform(element?.openingTimeHrs, 'HH:mm');
      let closeTime = this.datepipe.transform(element?.closingTimeHrs, 'HH:mm');
      element.openingHours = openTime + '-' + closeTime
      if (element.dayNumbers.includes(today)) {
        // this.businesshours = element.openingHours;
      }
    });
    this.appData.preferedDealer.occasionWiseOpeningHoursList.forEach(list => {
      let openTime = this.datepipe.transform(list?.openingTimeHrs, 'HH:mm');
      let closeTime = this.datepipe.transform(list?.closingTimeHrs, 'HH:mm');

      list.openingHours = openTime + '-' + closeTime
    });

    this.preferedDealer.occasionWiseOpeningHoursList.forEach(element => {
      let openTime = this.datepipe.transform(element?.openingTimeHrs, 'HH:mm');
      let closeTime = this.datepipe.transform(element?.closingTimeHrs, 'HH:mm');

      element.openingHours = openTime + '-' + closeTime
      if (element.dayNumbers.includes(today)) {
        this.businesshours = element.openingHours;
      }
    })
  }

  getNextYearDate() {
    let todaysDate = new Date();
    return new Date(todaysDate.getFullYear(), todaysDate.getMonth() + (+EnvSetting.FuturePlanningTime), todaysDate.getDate());
  }

  getDealerNotAvailableServicesFromSelectedServices(dealer: DealerService): string[] {
    const appData = this.commonService.getAppData();
    appData.selectedService.forEach((service) => {
      if (dealer.service) {
        dealer.service.forEach((dealerService) => {
          if (dealerService.serviceId === service.id) {
            service.isDisplayPriceForDealer = dealerService.isDisplayPrice
          }
        })
      }
    })
    return appData.selectedService.filter(x => {
      if (dealer.service) { return dealer.service.findIndex(y => y.serviceId === x.id) === -1; } return true;
    }).map(x => x.name);
  }

  getDealerRentalCars(): void {
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(x => {
      this.currentlanguage = x;
    })
    if (this.isNeedRentalCar) {
      this.isRentalCarSelectedError = true;
      this.spinner.show();
      this.isGenericRentalCar = this.features?.find(x => x.featureCode === CommonEnums.FeatureCode.GRentalCar)?.isActive;
      this.appData.isGenericRentalCar = this.isGenericRentalCar;
      if (!this.isGenericRentalCar) {
        this.showLegends = true;
        this.sdService.GetDealerRentalCars(this.preferedDealer.dealerId)
          .then((result) => {
            if (result.responseObject && result.responseObject.errorCount === 0 &&
              result.responseCode === CommonEnums.ErrorCodes.SuccessCode) {
              this.rentalCarAvailabilities = result.responseObject.result as RentalCar[];
              this.onChangeRentalCar();
            }
            this.spinner.hide();
          });
      }

      else {
        this.showLegends = false;
        this.currentlanguage = this.currentlanguage ? this.currentlanguage : 'en-US'
        //get generic rental car
        this.sdService.GetGenericRentalCars(this.currentlanguage)
          .then((result) => {
            if (result.responseObject && result.responseObject.errorCount === 0 &&
              result.responseCode === CommonEnums.ErrorCodes.SuccessCode) {
              this.genericRentalCarList = result.responseObject.result as GenericRentalCar[];
              this.onChangeGenericRentalCar();
            }
            this.spinner.hide();
          })
      }

    } else {
      this.isRentalCarSelectedError = false;
      this.onChangeRentalCar();
    }

  }

  async openDealerPopup() {
    this.timeSlotSection = false
    const modalRef = this.modalService.open(SelectDealerComponent);
    modalRef.componentInstance.allDealerDetails = this.allDealerDeatils;
    modalRef.componentInstance.latitude = this.preferedDealer.latitude;
    modalRef.componentInstance.longitude = this.preferedDealer.longitude;
    modalRef.componentInstance.preferedDealer = this.preferedDealer;
    modalRef.componentInstance.customerPickupDropOffServiceSelection = this.customerPickupDropOffServiceSelection;
    modalRef.result.then(async result => {
      if (result) {
        this.appData.selectedSlot = null;
        this.selectedSlot = null;
        this.IsShowPreferedDealer = true;
        await this.getAllDealerDetails();
        this.preferedDealer = this.allDealerDeatils.filter(x => x.dealerId == result)[0];
        this.NextAvailDate = Utility.GetFormattedDate(this.preferedDealer.nextAvailableDate)
        this.commonService.addPrefferedDealerdetails(this.preferedDealer);

        let existingVehicleCustomerDetails = this.commonService.getSelectedCustomerVehicleDetails();
        existingVehicleCustomerDetails.preferredDealerId = this.preferedDealer.dealerId;
        this.commonService.addSelectedCustomerVehicleDetails(existingVehicleCustomerDetails);

        this.selectedRentalCarIndex = -1;
        this.selectedGenericRentalCarIndex = undefined;
        this.isNeedRentalCar = false;
        this.selectedDate = this.NextAvailDate;
        this.defaultNextAvailableDate = this.preferedDealer.nextAvailableDate;
        const appData = this.commonService.getAppData();
        appData.selectedService.forEach((service) => {
          if (this.preferedDealer.service) {
            this.preferedDealer.service.forEach((dealerServices) => {
              if (dealerServices.serviceId === service.id) {
                service.isDisplayPriceForDealer = dealerServices.isDisplayPrice
              }
            })
          }
        })
        this.displaySelectedDate = this.preferedDealer.nextAvailableDate
        this.getBusineesHour(this.displaySelectedDate);
        this.checkRentalCarFeature(this.preferedDealer.dealerId);
        let service = appData.selectedService.map((x) => x.id).join(",");
        let dmsServiceIds = appData.selectedService.map((x) => x.dmsServiceId).join(",");
        const date = this.getNextYearDate();
        this.calculateTotalRepairTime();
        this.endDate = Utility.GetFormattedDate(date);
        if (!this.timeSlotSection && this.isNeedRentalCar) {
          this.getDealerRentalCars();
        }
        const selDate = new Date(this.preferedDealer.nextAvailableDate);
        if (this.time > +(EnvSetting.ShiftTime)) {
          await this.getDealerCapacity(this.preferedDealer?.dealerId, 0, (selDate.getUTCMonth() + 1), selDate.getUTCFullYear(), service, this.preferedDealer.nextAvailableDate);
          this.getSplitMechanicSlots(this.preferedDealer?.dealerId, selDate, this.time, service)
        }
        else {
          await this.getDealerCapacity(this.preferedDealer?.dealerId, this.time, (selDate.getUTCMonth() + 1), selDate.getUTCFullYear(), service, this.preferedDealer.nextAvailableDate);
          this.getMechanicSlots(this.preferedDealer?.dealerId, selDate, this.time, service,dmsServiceIds);
        }

        this.cdr.detectChanges();
        this.nextButtonDisableCheck();
      }
    });

  }

  showMap(): void {
    const modalRef = this.modalService.open(MapComponent);
    modalRef.componentInstance.latitude = this.preferedDealer.latitude;
    modalRef.componentInstance.longitude = this.preferedDealer.longitude;
    modalRef.componentInstance.preferedDealer = this.preferedDealer;
  }


  async changeDate(event: any) {
    this.appData.planningStartTime = null;
    this.appData.planningEndTime = null;
    this.appData.selectedSlot = null;
    const appData = this.commonService.getAppData();
    let service = appData.selectedService.map((x) => x.id).join(",");
    let dmsServiceIds = appData.selectedService.map((x) => x.dmsServiceId).join(",");
    this.selectedDate = Utility.GetFormattedDate(event);
    this.displaySelectedDate = event;
    this.IsShowPreferedDealer = true;
    this.appData.planningStartTime = appData?.planningStartTime;
    this.appData.planningEndTime = appData?.planningEndTime;
    await this.getAllDealerDetails();
    this.getBusineesHour(this.displaySelectedDate);
    if (this.time > +(EnvSetting.ShiftTime)) { this.getSplitMechanicSlots(this.preferedDealer?.dealerId, event, this.time, service) }
    else { this.getMechanicSlots(this.preferedDealer?.dealerId, event, this.time, service, dmsServiceIds) }
  }

  nextButtonDisableCheck(): void {
    if (this.preferedDealer) {
      this.disableNextButton = this.preferedDealer.notAvailableServices?.length > 0;
      if (this.isRentalCarSelected() && this.preferedDealer.notAvailableServices?.length == 0) {
        this.disableNextButton = this.getRentalCarAvailablilityStatus();
      }
      if (this.customerPickupDropOffServiceSelection && !this.preferedDealer.isVehiclePickUpAndDropOffService) {
        this.disableNextButton = true;
      }
      if (this.customerPickupDropOffServiceSelection && (this.pickUpHours == undefined || this.pickUpHours == 0) && (this.pickUpMinutes == undefined || this.pickUpMinutes == 0)) {
        this.disableNextButton = true;
      }
      if ((this.appData?.planningStartTime == undefined || this.appData?.planningStartTime == null) || (this.appData?.planningEndTime == undefined || this.appData?.planningEndTime == null)) {
        this.disableNextButton = true;
      }
    }
    else {
      this.disableNextButton = false;
    }

  }


  isRentalCarSelected(): boolean {
    return !this.timeSlotSection && this.isNeedRentalCar && this.selectedRentalCarIndex > -1;
  }

  rentalCarValidationCheck(): void {
    if (this.isRentalCarSelected()) {
      this.disableNextButton = false;
      this.rentalCarValidationMessage = this.getRentalCarAvailablilityStatus();
    } else {
      this.rentalCarValidationMessage = false;
    }
  }

  getRentalCarAvailablilityStatus(): boolean {
    return this.rentalCarAvailabilities[this.selectedRentalCarIndex]
      .notAvailableDates.map(date => Utility.GetFormattedDate(date)).findIndex(y => y === this.selectedDate) > -1;
  }

  onChangeMonthYear(event: Date): void {
    this.IsShowPreferedDealer = true;
    this.getAllDealerDetails();
    this.displaySelectedDate = event;
    const appData = this.commonService.getAppData();
    let service = appData.selectedService.map((x) => x.id).join(",");
    let dmsServiceIds = appData.selectedService.map((x) => x.dmsServiceId).join(",");
    let selectedDate = Utility.getDateStringToDate(this.endDate);
    if (new Date(event) < selectedDate && new Date(event) > new Date()) {
      if (this.time > +(EnvSetting.ShiftTime)) { this.getSplitMechanicSlots(this.preferedDealer?.dealerId, event, this.time, service) }
      else { this.getMechanicSlots(this.preferedDealer?.dealerId, event, this.time, service, dmsServiceIds) }
    }
    else {
      this.mechanicSlots = [];
    }
  }

  async disableDealerNotAvailableDates(date: any): Promise<void> {
    if (this.preferedDealer) {
      await this.disableDealerNotOpenDates();
      let disabledate = this.disableDealerHolidayDates();
      if (disabledate && disabledate?.length > 0) {
        await this.findNextDate(disabledate, date);
      }
      else {
        this.nextAvailbleDate = date;
      }
    }
  }

  disableDealerNotOpenDates(): void {
    this.enablePreviousClosedDates();
    const calendar = this.rentalCarBookingCalendar?.nativeElement?.querySelectorAll('.xdsoft_date:not(.xdsoft_disabled)');
    if (calendar && this.preferedDealer) {
      const dealerNotOpenDaysList = this.getNotOpenDaysOfDealer();
      for (const element of calendar) {
        const mainDate = this.getDateStringFromCalenderElement(element);
        const day = this.commonService.getFormatedDate(mainDate).getDay();
        const index = dealerNotOpenDaysList.findIndex(x => x === day);
        if (index === -1) {
          element.classList.remove('xdsoft_disabled');
        } else {
          element.classList.add('xdsoft_disabled');
          element.classList.add('closed');
        }
      }
    }
  }

  enablePreviousClosedDates() {
    const closedDates = this.rentalCarBookingCalendar?.nativeElement?.querySelectorAll('.xdsoft_date.closed');
    if (closedDates) {
      for (const element of closedDates) {
        element.classList.remove('xdsoft_disabled');
        element.classList.remove('closed');
      }
    }
  }

  disableDealerHolidayDates() {
    this.enablePreviousHolidayDates();
    let disableDates = [];
    this.preferedDealer?.holidaysList?.forEach(x => {
      x?.holidayDates.forEach(y => {
        const date = Utility.GetFormattedDate(y);
        disableDates.push(date);
      });
    });
    if (this.dealerCapacity && this.dealerCapacity.length > 0) {
      this.dealerCapacity?.forEach(c => {
        const d = Utility.GetFormattedDate(c.monthOfDate);
        disableDates.push(d);
      });
    }

    this.setClassOfCalender('holiday', disableDates);
    this.setClassOfCalender('xdsoft_disabled', disableDates);
    return disableDates;
  }
  async findNextDate(disableDates, da: any): Promise<void> {
    this.nextAvailbleDate = null;
    this.selectedDate = '';
    this.displaySelectedDate = null;
    this.dealerNextAvailDate = '';

    if (disableDates && disableDates.length > 0) {
      let date = disableDates
        .map((x) => {
          let splits = x.split(".");
          return new Date(splits[2], splits[1] - 1, splits[0]);
        });
      let d = new Date(new Date(this.preferedDealer.nextAvailableDate).setHours(0, 0, 0, 0));
      if ((date.findIndex(x => x.getTime() === d.getTime()) === -1) && (da === this.preferedDealer.nextAvailableDate)) {
        this.nextAvailbleDate = this.preferedDealer.nextAvailableDate;
        this.dealerNextAvailDate = Utility.GetFormattedDate(this.preferedDealer.nextAvailableDate);
        this.selectedDate = this.dealerNextAvailDate;
        this.displaySelectedDate = this.preferedDealer.nextAvailableDate;
      }
      else {
        this.nextAvailbleDate = da;
        this.dealerNextAvailDate = Utility.GetFormattedDate(this.preferedDealer.nextAvailableDate);
        this.selectedDate = Utility.GetFormattedDate(da);
        this.displaySelectedDate = da;
      }
    }
    else {
      this.nextAvailbleDate = da;
      this.dealerNextAvailDate = Utility.GetFormattedDate(this.preferedDealer.nextAvailableDate);
      this.selectedDate = Utility.GetFormattedDate(da);
      this.displaySelectedDate = da;
    }
  }

  enablePreviousHolidayDates() {
    const holidayDates = this.rentalCarBookingCalendar?.nativeElement?.querySelectorAll('.xdsoft_date.holiday');
    if (holidayDates) {
      for (const element of holidayDates) {
        element.classList.remove('xdsoft_disabled');
        element.classList.remove('holiday');
      }
    }
  }
  getNotOpenDaysOfDealer(): number[] {
    const dealerNotOpenDaysList: number[] = [];
    const dealerOpenDaysList: number[] = [];
    let dealerNotOpenDays2DList = this.preferedDealer.openingHoursList.filter(x => x.isOpen).map(x => x.dayNumbers);
    dealerNotOpenDays2DList.forEach(days => {
      dealerOpenDaysList.push(...days);
    });
    for (let i = 0; i <= 6; i++) {
      if (dealerOpenDaysList.indexOf(i) === -1) {
        dealerNotOpenDaysList.push(i);
      }
    }
    return dealerNotOpenDaysList;
  }
  calculateDateTime(selectedDate, Hour, Minute): Date {
    let dateArray = selectedDate.split('.');
    let date = +dateArray[0];
    let month = +dateArray[1];
    let year = +dateArray[2];
    let minute = isNullOrUndefined(Minute) ? 0 : Minute;
    return new Date(year, month - 1, date, +Hour, +minute);
  }

  onSelectDateNext(): void {
    this.currentLanguageService.currentLanguage.subscribe(x => {
      this.currentLanguage = x
    });
    const appData = this.commonService.getAppData();

    this.currentLanguageService.currentLanguage.subscribe(x => {
      this.currentLanguage = x
    });
    let selectedCustomerVehicle = this.commonService.getSelectedCustomerVehicleDetails();
    //#region reserve slot
    if (this.time > +(EnvSetting.ShiftTime) && this.splitMechanicSlots?.length > 0) {
      this.planningStartDate = this.tempslot?.startDate;
      this.planningEndDate = this.tempslot?.endDate;
      this.appData.splitSlots = this.splitMechanicSlots;
      this.commonService.addSplitSlot(this.splitMechanicSlots);
      this.splitMechanicSlots.forEach((slot) => {
        let timeStart = new Date(slot.startDate).getTime();
        let timeEnd = new Date(slot.endDate).getTime();
        let hourDiff = timeEnd - timeStart; //in ms
        let minDiff = hourDiff / 60 / 1000; //in minutes
        let Obj: ReserveSlotsTime = {
          Duration: minDiff,
          SelectedDateTime: slot.startDate,
          SlectedDate: slot.startDate
        }
        let planningObj: PlanningSlots = {
          PlanningEndDate: slot?.endDate,
          PlanningStartDate: slot?.startDate
        }
        this.PlanningSlots.push(planningObj);
        this.ReserveSlotsTime.push(Obj);
      })
    }
    else {
      this.planningStartDate = this.tempslot?.startTime;
      this.planningEndDate = this.tempslot?.endTime;
      let Obj: ReserveSlotsTime = {
        Duration: Utility.GetEfficientPlanningTime(this.tempslot?.efficiency,this.time),
        SelectedDateTime: this.tempslot?.startTime,
        SlectedDate: this.tempslot?.startTime
      }
      let planningObj: PlanningSlots = {
        PlanningEndDate: this.tempslot?.endTime,
        PlanningStartDate: this.tempslot?.startTime
      }
      this.PlanningSlots.push(planningObj);
      this.ReserveSlotsTime.push(Obj)
    }
    this.appData.planningStartTime = this.planningStartDate;
    this.appData.planningEndTime = this.planningEndDate;
    this.commonService.addPlanningDate(this.planningStartDate, this.planningEndDate, this.tempslot?.mechanicId);
    this.commonService.addPlanningSlots(this.PlanningSlots);
    this.commonService.addSelectedSlot(this.selectedSlot);
    let d = new Date(this.planningStartDate)
    let formattedDate = (d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()).toString();
    const iso = moment.utc(formattedDate,"YYYY-MM-DD").toISOString()
    const startTime = this.tempslot?.startTime;

    let model = {
      LicensePlate: selectedCustomerVehicle?.licensePlateNo,
      MobileNo: this.appData.userAuthMobile,
      SlectedDate: iso,
      StartTime: null,
      Duration: this.time,
      MechanicId: this.tempslot?.mechanicId,
      DealerId: this.appData.preferedDealer?.dealerId,
      CustomerName: (selectedCustomerVehicle?.cusT_NAME != null) ? selectedCustomerVehicle?.cusT_NAME : selectedCustomerVehicle?.dfcusT_NAME,
      Brand: (selectedCustomerVehicle?.companyMakeCode != null) ? selectedCustomerVehicle?.companyMakeCode : selectedCustomerVehicle?.dfCompanyMakeName,
      SelectedDateTime: iso,
      ReserveSlotsTimes: this.ReserveSlotsTime
    }
    let service = appData.selectedService.map((x) => x.id).join(",");
    let dmsServiceIds = appData.selectedService.map((x) => x.dmsServiceId).join(",");
    this.sdService.CheckReserveSlotAvailability(model).then((response) => {
      if (response && response.responseCode === CommonEnums.ErrorCodes.SuccessCode && response.responseObject === true) {
        this.sdService.ReserveSlot(model).then((res) => {
          // res && res?.responseObject && res?.responseObject?.errorCount === 0
          if (res?.responseObject?.errorCount === 0  ) {
            this.appData.reserveSlotId = res?.responseObject?.result;
            if(this.widgetAppointmentTimer){
              this.commonService.startExpireTimer(+EnvSetting.SlotExpireMinutes);
            }
            this.commonService.addReserveSlot(res?.responseObject?.result, startTime);

            let mileage = (appData.mileage == null)
                ? ((selectedCustomerVehicle.previousKilometer == null) ? 0 : selectedCustomerVehicle.previousKilometer)
                : appData.mileage;

              this.sdService.GetServicesByDealerId(
                this.preferedDealer.dealerId,
                this.currentLanguage,
                selectedCustomerVehicle.companyMakeCode,
                selectedCustomerVehicle.vehicleType,
                selectedCustomerVehicle.fuelType,
                mileage,
                0
              ).then(result => {
                if (result.responseCode === CommonEnums.ErrorCodes.SuccessCode) {
                  this.DealerServiceResp = result.responseObject.result;
                  if (this.DealerServiceResp.length > 0) {
                    this.commonService.updateServicePrice(this.DealerServiceResp);
                  }
                }
              });
          }
        })
        // Calculation for Appointment Time
        let OpeningClosingAppHour;
        let openingAppHour, closingAppHour;
        let selectedDayNumber;
        selectedDayNumber = Utility.getDateStringToDate(this.selectedDate).getDay();
        this.preferedDealer.openingHoursList.forEach(element => {
          if (element.isOpen) {
            element.dayNumbers.forEach(dayNo => {
              if (dayNo === selectedDayNumber) {
                let openTime = this.datepipe.transform(element?.openingTimeHrs, 'HH:mm');
                let closeTime = this.datepipe.transform(element?.closingTimeHrs, 'HH:mm');
                
                element.openingHours = openTime + '-' + closeTime
                OpeningClosingAppHour = element.openingHours.split("-", 2);
                openingAppHour = OpeningClosingAppHour[0].split(":", 2);
                closingAppHour = OpeningClosingAppHour[1].split(":", 2);
              }
            });
          }
        });
        let openingHrs: number = +openingAppHour[0];
        let closingHrs: number = +closingAppHour[0];
        this.AppointmentDatetime = this.calculateDateTime(this.selectedDate, Utility.ConvertUTCDateToLocalTime(this.planningStartDate).split(":", 2)[0], Utility.ConvertUTCDateToLocalTime(this.planningStartDate).split(":", 2)[1])
        let currentDate = new Date;
        if (this.selectedDate == Utility.GetFormattedDate(currentDate)) {
          if (this.AppointmentDatetime < currentDate) {
            let errorMsg = this.translateService.instant("lblAppropiateAppointmentTimeRequired");
            this.toastr.error(errorMsg);
            this.spinner.hide();
            return;
          }
        }

        // Calculation for Pickup Time
        let OpeningClosingHour;
        this.preferedDealer.openingHoursList.forEach(element => {
          if (element.isOpen) {
            element.dayNumbers.forEach(dayNo => {
              if (dayNo === selectedDayNumber) {
                let openTime = this.datepipe.transform(element?.openingTimeHrs, 'HH:mm');
                let closeTime = this.datepipe.transform(element?.closingTimeHrs, 'HH:mm');
                element.openingHours = openTime + '-' + closeTime
                OpeningClosingAppHour = element.openingHours.split("-", 2);
                openingAppHour = OpeningClosingAppHour[0].split(":", 2);
                closingAppHour = OpeningClosingAppHour[1].split(":", 2);
              }
            });
          }
        });

        if (this.customerPickupDropOffServiceSelection) {
          // if true
          if (this.pickUpHours == 0) {
            let errorMsg = this.translateService.instant("lblPickUpTimeRequired");
            this.toastr.error(errorMsg);
            return;
          }
          let openingHr: number = +openingHrs;
          let closingHr: number = +closingHrs;
          OpeningClosingHour = ' ' + openingHr + '-' + closingHr;
          if ((this.pickUpHours < openingHr || this.pickUpHours > closingHr || (this.pickUpHours == closingHr && this.pickUpMinutes > 0))) {
            let errorMsg = this.translateService.instant("lblSelectApproriatePickuphourbetween");
            this.toastr.error(errorMsg + OpeningClosingHour);
            return;
          }
        }
        this.PickupDatetime = this.calculateDateTime(this.selectedDate, this.pickUpHours, this.pickUpMinutes)

        if (this.disableNextButton) {
          if (this.timeSlotSection) {
            this.isPickupFormSubmitted = true;
          }
          return;
        }
        if (this.isNeedRentalCar && (this.selectedRentalCarIndex < 0 || this.selectedRentalCarIndex === undefined)) {
          if (!this.isGenericRentalCar && (this.selectedRentalCarIndex < 0 || this.selectedRentalCarIndex === undefined)) {
            this.isRentalCarSelectedError = true;
            return;
          }
          if (this.isGenericRentalCar && (this.selectedGenericRentalCarIndex < 0 || this.selectedGenericRentalCarIndex === undefined)) {
            this.isRentalCarSelectedError = true;
            return;
          }
        }
        this.changeSection(Constant.selectWorkshopSectionConstant.finalSummarySection);
      }
      else {
        let errorMsg = this.translateService.instant("lblSelectAnotherSlot");
        this.toastr.error(errorMsg);
        this.getMechanicSlots(this.preferedDealer?.dealerId, new Date(this.preferedDealer.nextAvailableDate), this.time, service, dmsServiceIds)
      }
    })
    //#endregion
  }

  onChangeInCalender(event): void {
    const appData = this.commonService.getAppData();
    if (this.isRentalCarSelected()) {
      this.makeAvailableDateGeenInCalender();
    } else {
      this.rentalCarValidationMessage = false;
      this.removeClassFromCalender('date-green-bg');
    }
   
    let service = appData.selectedService.map((x) => x.id).join(",");
    let selectedDate = Utility.getDateStringToDate(this.endDate);
    if (new Date(event) < selectedDate && new Date(event) > new Date()) {
      if (this.time > +(EnvSetting.ShiftTime)) {
        this.getDealerCapacity(this.preferedDealer?.dealerId, 0, (new Date(event).getMonth() + 1), new Date(event).getUTCFullYear(), service, event);
      }
      else {
        this.getDealerCapacity(this.preferedDealer?.dealerId, this.time, (new Date(event).getMonth() + 1), new Date(event).getUTCFullYear(), service, event);
      }
    }
    this.rentalCarValidationCheck();
    this.nextButtonDisableCheck();
  }
  getMechanicSlots(dealerId: string, date: any, estimatedTime: any, service: string, dmsServiceIds: string) {
    this.mechanicSlots = [];
    if (date != undefined && date != null) {
      let d = new Date(date)
      let formattedDate = (d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()).toString();
      const iso = moment.utc(formattedDate,"YYYY-MM-DD").toISOString()
      let vehicleDetail = this.commonService.getSelectedCustomerVehicleDetails();
      let model = {
        DealerId: dealerId,
        Date: iso,

        EstimatedTime: +((+estimatedTime.toFixed(2)) / 60).toFixed(2),
        ServiceIds: service,
        vehicleType: vehicleDetail.vehicleType,
        companyMakeCode: vehicleDetail.companyMakeCode,
        licensePlate: vehicleDetail.licensePlateNo,
        DmsServiceIds: dmsServiceIds
      }
      this.spinner.show();
      this.sdService.GetMechanicSlots(model).then((res) => {
        if (res?.responseObject?.result && res?.responseObject?.result?.length > 0) {
          this.mechanicSlots = res?.responseObject?.result;
          this.mechanicSlots?.forEach(x => {
            let sameDateSlots = this.mechanicSlots?.filter((slot) => new Date(slot.startTime).getTime() === new Date(x.startTime).getTime())
            if (sameDateSlots?.length > 1) {
              sameDateSlots = sameDateSlots.sort((a,b) => b.efficiency - a.efficiency);
              let removedSlots =  sameDateSlots[sameDateSlots.length - 1];
              //let removedSlots = sameDateSlots?.find((slot) => slot.mechanicId !== x.mechanicId)
              let index = this.mechanicSlots.indexOf(removedSlots);
              if (index > -1) {
                this.mechanicSlots.splice(index, 1); // Remove array element
              }
            }
          });
          this.commonService.addCalenderNumber(this.mechanicSlots[0]?.calendarNumber)
          this.mechanicSlots?.forEach(x => {
            x.startTimeLocal = Utility.ConvertUTCDateToLocalDate(x.startTime);
            x.endTimeLocal = Utility.ConvertUTCDateToLocalDate(x.endTime);

          });
          this.mechanicSlots = this.mechanicSlots.sort((a,b)=> a.startTimeLocal - b.startTimeLocal)

          //--------------------
          //for QA and UAT only for testing purpose
          // if today's date then remove  slots which are of past time from curremt time
          if (EnvSetting.IsActiveTodayBooking) {
            if (new Date().toDateString() === new Date(date).toDateString()) {
              this.mechanicSlots = this.mechanicSlots.filter(x => x.startTimeLocal > new Date());
            }
            this.disableDealerHolidayDates()
            this.cdr.detectChanges();
          }
        }
        this.spinner.hide();
      })
    }
  }
  getSplitMechanicSlots(dealerId: string, date: any, estimatedTime: any, service: string) {
    this.mechanicSlots = [];
    this.splitMechanicSlots = [];
    if (date != undefined && date != null) {
      let d = new Date(date)
      let formattedDate = (d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()).toString();
      const iso = moment.utc(formattedDate,"YYYY-MM-DD").toISOString()
      let vehicleDetail = this.commonService.getSelectedCustomerVehicleDetails();
      let model = {
        DealerId: dealerId,
        StartDateTime: iso,
        MechanicId: 0,
        DurationInMin: +(+estimatedTime.toFixed(2)).toFixed(2),
        ServiceIds: service,
        vehicleType: vehicleDetail.vehicleType,
        companyMakeCode: vehicleDetail.companyMakeCode
      }
      this.spinner.show();
      this.sdService.GetSplitMechanicSlots(model).then((res) => {
        if (res?.responseObject?.result && res?.responseObject?.result?.length > 0) {
          this.splitMechanicSlots = res?.responseObject?.result;
          this.splitMechanicSlots?.forEach(x => {
            let sameDateSlots = this.splitMechanicSlots?.filter((slot) => new Date(slot.startTime).getTime() === new Date(x.startTime).getTime())
            if (sameDateSlots?.length > 0) {
              let removedSlots = sameDateSlots?.find((slot) => slot.mechanicId !== x.mechanicId)
              let index = this.splitMechanicSlots.indexOf(removedSlots);
              if (index > -1) {
                this.splitMechanicSlots.splice(index, 1); // Remove array element
              }
            }
          });
          this.splitMechanicSlots.forEach(x => {
            x.startTimeLocal = Utility.ConvertUTCDateToLocalDate(x.startDate);
            x.endTimeLocal = Utility.ConvertUTCDateToLocalDate(x.endDate);
          })
          this.splitMechanicSlots.forEach((slot) => {
            let startDate = slot.startDate;
            if (new Date(startDate).getDate() === d.getDate()) {
              let timeStart = new Date(slot.startDate).getTime();
              let timeEnd = new Date(slot.endDate).getTime();
              let hourDiff = timeEnd - timeStart; //in ms
              let minDiff = hourDiff / 60 / 1000;
              if (minDiff > +(EnvSetting.MinimunTimeSlot)) {
                this.mechanicSlots.push(slot);
              }
            }
          })
        }
        this.spinner.hide();
      })
    }
  }
  isSlotSelected(slot){
    let isSelected = false;
    if (this.selectedSlot) {
      if (this.selectedSlot.startTime != undefined
        && this.selectedSlot.endTime != undefined
        && this.selectedSlot?.mechanicId == slot.mechanicId
        && this.selectedSlot?.startTime == slot.startTime
        && this.selectedSlot?.endTime == slot.endTime) {
          isSelected = true;
      }
      else if (this.selectedSlot.startDate != undefined
        && this.selectedSlot.endDate != undefined
    && this.selectedSlot?.mechanicId == slot.mechanicId
        && this.selectedSlot?.startDate == slot.startDate
        && this.selectedSlot?.endDate == slot.endDate) {
          isSelected = true;
      }
    }
    return isSelected;
  }
  SelectSlots(slot: any) {
    this.appData.selectedSlot = null;
    this.selectedSlot = null;
    this.ReserveSlotsTime = [];
    this.PlanningSlots = [];


    this.tempslot = slot;
    this.appData.selectedSlot = slot;
    this.selectedSlot = slot;
    if (this.time > +(EnvSetting.ShiftTime) && this.splitMechanicSlots?.length > 0) {
      this.planningStartDate = slot?.startDate;
      this.planningEndDate = slot?.endDate;
      this.appData.splitSlots = this.splitMechanicSlots;
      this.commonService.addSplitSlot(this.splitMechanicSlots);
    }
    else {
      this.planningStartDate = slot?.startTime;
      this.planningEndDate = slot?.endTime;
    }
    this.appData.planningStartTime = this.planningStartDate;
    this.appData.planningEndTime = this.planningEndDate;

    this.nextButtonDisableCheck();
    //this.PlanningTime = this.selectedDate
  }
  applyRentalCarChangesOnCalender(): void {
    if (this.isRentalCarSelected()) {
      this.makeAvailableDateGeenInCalender();
    } else {
      this.rentalCarValidationMessage = false;
      this.removeClassFromCalender('date-green-bg');
    }
    this.nextButtonDisableCheck();
  }
  RentalCarValidationMessage(){
    if (this.isNeedRentalCar) {
      if (!this.isGenericRentalCar && this.selectedRentalCarIndex > 0) {
        this.isRentalCarSelectedError = false;
      }
      else if (this.isGenericRentalCar && this.selectedGenericRentalCarIndex > 0) {
        this.isRentalCarSelectedError = false;
      }
      else{
        this.isRentalCarSelectedError = true;
      }
    }
    else{
      this.isRentalCarSelectedError = false;
    }
  }
  onChangeRentalCar() {
    this.rentalCarValidationCheck();
    this.applyRentalCarChangesOnCalender();
    let selectedRentalCar = this.rentalCarAvailabilities.filter(x => x.vehicleId === this.selectedRentalCarIndex)[0];
    if(selectedRentalCar && selectedRentalCar != undefined){
      this.genericRentalCar.licensePlate = selectedRentalCar.licensePlate.toString();
      this.genericRentalCar.makeName = selectedRentalCar.makeName;
      this.genericRentalCar.model = selectedRentalCar.model;
      this.genericRentalCar.price = selectedRentalCar.price;
      this.genericRentalCar.notAvailableDates = selectedRentalCar.notAvailableDates;
      this.genericRentalCar.vehicleId = selectedRentalCar.vehicleId;
    }
    this.commonService.addSelectedRentalCar(selectedRentalCar);
    this.RentalCarValidationMessage();
  }
  onChangeGenericRentalCar() {
    this.appData.genericRentalCar = this.genericRentalCarList.filter(x => x.typeId === this.selectedGenericRentalCarIndex)[0];
    this.commonService.addGenericRentalCarData(this.isGenericRentalCar, this.appData.genericRentalCar);
    this.RentalCarValidationMessage();
  }
  makeAvailableDateGeenInCalender() {
    const notAvailableDate = this.rentalCarAvailabilities[this.selectedRentalCarIndex]?.notAvailableDates;
    if (notAvailableDate) {
      const notAvailableDateStrings = notAvailableDate.map(x => Utility.GetFormattedDate(x));
      this.setClassOfCalenderExcept('date-green-bg', notAvailableDateStrings);
    }
  }

  setClassOfCalender(className: string, data: any[], flag: boolean = true): void {
    const calendar = this.rentalCarBookingCalendar?.nativeElement?.querySelectorAll('.xdsoft_date:not(.xdsoft_disabled)');
    if (calendar) {
      // tslint:disable-next-line: no-shadowed-variable
      for (const element of calendar) {
        const mainDate = this.getDateStringFromCalenderElement(element);
        for (const availableDate of data) {
          if (mainDate === availableDate) {
            if (flag) {
              element.classList.add(className);
            } else {
              element.classList.remove(className);
            }
          }
        }
      }
    }
  }

  removeClassFromCalender(className: string): void {
    const calendar = this.rentalCarBookingCalendar?.nativeElement?.querySelectorAll('.xdsoft_date');
    if (calendar) {
      // tslint:disable-next-line: no-shadowed-variable
      for (const element of calendar) {
        element.classList.remove(className);
      }
    }
  }

  setClassOfCalenderExcept(className: string, data: string[]): void {
    const calendar = this.rentalCarBookingCalendar?.nativeElement?.querySelectorAll('.xdsoft_date:not(.xdsoft_disabled)');
    if (calendar) {
      // tslint:disable-next-line: no-shadowed-variable
      for (const element of calendar) {
        const mainDate = this.getDateStringFromCalenderElement(element);
        const index = data.findIndex(x => x === mainDate);
        if (index !== -1) {
          element.classList.remove(className);
        } else {
          element.classList.add(className);
        }
      }
    }
  }

  getDateStringFromCalenderElement(calElement: any): string {
    let dataDate = calElement.getAttribute('data-date');
    const dataMonth = calElement.getAttribute('data-month');
    const dataYear = calElement.getAttribute('data-year');

    if (dataDate.length === 1) {
      dataDate = '0' + dataDate;
    }
    let finalMonthValue = String(+dataMonth + 1);
    if (finalMonthValue.length === 1) {
      finalMonthValue = '0' + finalMonthValue;
    }
    return dataDate + '.' + finalMonthValue + '.' + dataYear;
  }

  changeSection(key: string): void {
    Object.keys(this.sections).forEach(x => {
      if (x === key) {
        this.sections[x] = true;
      } else {
        this.sections[x] = false;
      }
    });
  }
}
